/**
 * Item Fake Data Service
 * Contains fake data for development and testing
 */

const itemFakeDataService = (() => {
    // Fake data similar to a_item_frame.html
    const fakeData = [
        {
            id: 1,
            item_name: 'Thùng đóng gói cao cấp',
            item_type: '在庫品',
            status: '新入荷',
            warehouse: 'HCM – Quận 7',
            staff: 'Nguyễn Văn A',
            customer: 'Công ty TNHH ABC',
            product_code: 'PRD1001',
            price: 500,
            stock: 18,
            storage_time: '1年2ヶ月',
            period: '残り6ヶ月',
            dimensions: '幅300mm×マチ120mm×高350mm',
            case_info: [
                { quantity_per_case: 1000, number_of_cases: 5 },
                { quantity_per_case: 500, number_of_cases: 3 },
                { quantity_per_case: 200, number_of_cases: 10 }
            ],
            date: '2025-06-08 09:15',
            status_ids: [2, 4]
        },
        {
            id: 2,
            item_name: 'Túi đựng thực phẩm',
            item_type: '預かり品',
            status: '在庫切れ・間近',
            warehouse: 'Hà Nội – Hoàng Mai',
            staff: 'Trần Thị B',
            customer: 'Công ty TNHH XYZ',
            product_code: 'PRD1002',
            price: 300,
            stock: 0,
            storage_time: '6ヶ月',
            period: '残り6ヶ月',
            dimensions: '幅250mm×マチ100mm×高300mm',
            case_info: [
                { quantity_per_case: 1000, number_of_cases: 2 },
                { quantity_per_case: 300, number_of_cases: 8 },
                { quantity_per_case: 150, number_of_cases: 20 }
            ],
            date: '2025-05-01 14:00',
            status_ids: [5]
        },
        {
            id: 3,
            item_name: 'Hộp mỹ phẩm nhỏ',
            item_type: '預かり品',
            status: '製造仕掛り中',
            warehouse: 'Đà Nẵng – Hải Châu',
            staff: 'Lê Văn C',
            customer: 'Công ty ABCD',
            product_code: 'PRD1003',
            price: 150,
            stock: 40,
            storage_time: '2年',
            period: '残り24ヶ月',
            dimensions: '幅180mm×マチ90mm×高220mm',
            case_info: [
                { quantity_per_case: 1000, number_of_cases: 1 },
                { quantity_per_case: 800, number_of_cases: 2 },
                { quantity_per_case: 500, number_of_cases: 3 },
                { quantity_per_case: 250, number_of_cases: 4 }
            ],
            date: '2025-04-15 10:00',
            status_ids: [1]
        },
        {
            id: 4,
            item_name: 'Thùng carton lớn',
            item_type: '在庫品',
            status: '保管終了・間近',
            warehouse: 'HCM – Tân Bình',
            staff: 'Ngô Thị D',
            customer: 'Công ty EFG',
            product_code: 'PRD1004',
            price: 750,
            stock: 25,
            storage_time: '8ヶ月',
            period: '残り8ヶ月',
            dimensions: '幅500mm×マチ200mm×高400mm',
            case_info: [
                { quantity_per_case: 1000, number_of_cases: 4 },
                { quantity_per_case: 100, number_of_cases: 20 }
            ],
            date: '2025-07-10 08:30',
            status_ids: [3]
        },
        {
            id: 5,
            item_name: 'Túi mini đựng quà',
            item_type: '預かり品',
            status: '在庫切れ間近',
            warehouse: 'Hà Nội – Cầu Giấy',
            staff: 'Phạm Văn E',
            customer: 'Công ty JKL',
            product_code: 'PRD1005',
            price: 100,
            stock: 3,
            storage_time: '1ヶ月',
            period: '超過１ヶ月',
            dimensions: '幅100mm×マチ50mm×高150mm',
            case_info: [
                { quantity_per_case: 1000, number_of_cases: 1 },
                { quantity_per_case: 800, number_of_cases: 2 },
                { quantity_per_case: 600, number_of_cases: 2 },
                { quantity_per_case: 300, number_of_cases: 5 }
            ],
            date: '2025-07-01 12:00',
            status_ids: [2, 5]
        },
        {
            id: 6,
            item_name: 'Hộp đựng điện tử',
            item_type: '在庫品',
            status: '新入荷',
            warehouse: 'Tokyo – Shibuya',
            staff: 'Yamada Taro',
            customer: '株式会社テクノロジー',
            product_code: 'PRD1006',
            price: 1200,
            stock: 12,
            storage_time: '3ヶ月',
            period: '残り3ヶ月',
            dimensions: '幅200mm×マチ150mm×高100mm',
            case_info: [
                { quantity_per_case: 500, number_of_cases: 3 },
                { quantity_per_case: 200, number_of_cases: 8 }
            ],
            date: '2025-08-15 14:30',
            status_ids: [1]
        },
        {
            id: 7,
            item_name: 'Bao bì thực phẩm',
            item_type: '預かり品',
            status: '保管終了・間近',
            warehouse: 'Osaka – Namba',
            staff: 'Sato Hanako',
            customer: 'フード株式会社',
            product_code: 'PRD1007',
            price: 80,
            stock: 0,
            storage_time: '1年',
            period: '超過2ヶ月',
            dimensions: '幅150mm×マチ100mm×高80mm',
            case_info: [
                { quantity_per_case: 2000, number_of_cases: 2 },
                { quantity_per_case: 1000, number_of_cases: 5 }
            ],
            date: '2024-12-01 09:00',
            status_ids: [4]
        },
        {
            id: 8,
            item_name: 'Thùng vận chuyển',
            item_type: '在庫品',
            status: '製造仕掛り中',
            warehouse: 'Yokohama – Minato',
            staff: 'Tanaka Kenji',
            customer: 'ロジスティクス株式会社',
            product_code: 'PRD1008',
            price: 2000,
            stock: 5,
            storage_time: '6ヶ月',
            period: '残り4ヶ月',
            dimensions: '幅400mm×マチ300mm×高250mm',
            case_info: [
                { quantity_per_case: 100, number_of_cases: 2 },
                { quantity_per_case: 50, number_of_cases: 4 }
            ],
            date: '2025-06-20 11:45',
            status_ids: [3]
        }
    ];

    // Status mapping for display
    const statusMap = {
        1: { name: '新入荷', class: 'bg-orange-100 text-orange-600' },
        2: { name: '在庫切れ・間近', class: 'bg-blue-100 text-blue-600' },
        3: { name: '製造仕掛り中', class: 'bg-yellow-100 text-yellow-700' },
        4: { name: '保管終了・間近', class: 'bg-green-100 text-green-600' },
        5: { name: '在庫切れ間近', class: 'bg-yellow-100 text-yellow-800' }
    };

    // Get all fake data
    const getAllData = () => {
        return [...fakeData];
    };

    // Get data with pagination
    const getPaginatedData = (page = 1, pageSize = 20) => {
        const startIndex = (page - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        const paginatedData = fakeData.slice(startIndex, endIndex);

        return {
            data: paginatedData,
            total: fakeData.length,
            page,
            pageSize,
            totalPages: Math.ceil(fakeData.length / pageSize)
        };
    };

    // Get data with sorting
    const getSortedData = (field = 'item_name', direction = 'asc') => {
        const sortedData = [...fakeData].sort((a, b) => {
            let valA = a[field] || '';
            let valB = b[field] || '';

            if (!isNaN(Number(valA)) && !isNaN(Number(valB))) {
                valA = Number(valA);
                valB = Number(valB);
            }

            const comparison = valA < valB ? -1 : valA > valB ? 1 : 0;
            return direction === 'asc' ? comparison : -comparison;
        });

        return sortedData;
    };

    // Status filter mapping
    const statusFilterMap = {
        new: '新入荷',
        'low-stock': '在庫切れ・間近',
        'in-progress': '製造仕掛り中',
        expiring: '保管終了・間近'
    };

    // Get data with filtering
    const getFilteredData = (filters = {}) => {
        let filteredData = [...fakeData];

        if (filters.status) {
            const statusName = statusFilterMap[filters.status] || filters.status;
            filteredData = filteredData.filter(item => item.status === statusName);
        }

        if (filters.item_type) {
            filteredData = filteredData.filter(item => item.item_type === filters.item_type);
        }

        if (filters.q) {
            const searchTerm = filters.q.toLowerCase();
            filteredData = filteredData.filter(
                item =>
                    item.item_name.toLowerCase().includes(searchTerm) ||
                    item.product_code.toLowerCase().includes(searchTerm) ||
                    item.customer.toLowerCase().includes(searchTerm) ||
                    item.staff.toLowerCase().includes(searchTerm)
            );
        }

        return filteredData;
    };

    // Get combined data with pagination, sorting, and filtering
    const getData = (params = {}) => {
        const { page = 1, pageSize = 20, sortField = 'item_name', sortType = 'asc', ...filters } = params;

        let data = getFilteredData(filters);
        data = getSortedData(sortField, sortType);

        const startIndex = (page - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        const paginatedData = data.slice(startIndex, endIndex);

        return {
            status: 'success',
            data: {
                dataTable: paginatedData,
                pagination: {
                    pageCurrent: page,
                    pageSize,
                    pageTotal: Math.ceil(data.length / pageSize)
                },
                dataCount: data.length
            }
        };
    };

    // Get status map
    const getStatusMap = () => {
        return statusMap;
    };

    // Add new item
    const addItem = itemData => {
        const newId = Math.max(...fakeData.map(item => item.id)) + 1;
        const newItem = {
            id: newId,
            ...itemData,
            date: new Date().toISOString().slice(0, 19).replace('T', ' ')
        };
        fakeData.push(newItem);
        return newItem;
    };

    // Update item
    const updateItem = (itemId, itemData) => {
        const index = fakeData.findIndex(item => item.id === itemId);
        if (index !== -1) {
            fakeData[index] = { ...fakeData[index], ...itemData };
            return fakeData[index];
        }
        return null;
    };

    // Delete item
    const deleteItem = itemId => {
        const index = fakeData.findIndex(item => item.id === itemId);
        if (index !== -1) {
            return fakeData.splice(index, 1)[0];
        }
        return null;
    };

    return {
        getAllData,
        getPaginatedData,
        getSortedData,
        getFilteredData,
        getData,
        getStatusMap,
        addItem,
        updateItem,
        deleteItem
    };
})();

export default itemFakeDataService;
